import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

const StepTo2D = () => {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();
  const [stepFile, setStepFile] = useState(null);
  const [selectedViews, setSelectedViews] = useState([]);
  const [fileLinks, setFileLinks] = useState({});

  const handleFileChange = (e) => setStepFile(e.target.files[0]);

  const handleViewChange = (e) => {
    const { value, checked } = e.target;
    if (checked) setSelectedViews([...selectedViews, value]);
    else setSelectedViews(selectedViews.filter((v) => v !== value));
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!stepFile) return alert("Please select a STEP file!");
    if (selectedViews.length === 0) return alert("Please select at least one view!");

    const formData = new FormData();
    formData.append("file", stepFile);
    formData.append("user_email", userEmail);
    formData.append("views", JSON.stringify(selectedViews));

    try {
      const response = await fetch("https://www.d-rosa.ai/stepto2d", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        setFileLinks(data);
        alert("STEP converted successfully for selected views!");
      } else {
        const err = await response.json();
        alert("Error: " + (err.error || "Conversion failed"));
      }
    } catch (error) {
      console.error("Error uploading STEP file:", error);
    }
  };

  return (
    <div>
      <center><h2>STEP ? 2D Converter (DXF & PDF)</h2></center>
      <p>Signed in as: {userEmail}</p>

      <form onSubmit={handleUpload}>
        <input type="file" accept=".step,.stp" onChange={handleFileChange} /><br /><br />
        <h4>Select Views:</h4>
        <label><input type="checkbox" value="top" onChange={handleViewChange} /> Front View</label><br />
        <label><input type="checkbox" value="front" onChange={handleViewChange} /> Top View</label><br />
        <label><input type="checkbox" value="side" onChange={handleViewChange} /> Side View</label><br /><br />
        <button type="submit">STEP TO 2D</button>
      </form>

      {Object.keys(fileLinks).length > 0 && (
        <div>
          <h3>Download & Preview Files</h3>
          {Object.entries(fileLinks).map(([view, urls]) => (
            <div key={view} style={{ marginBottom: "30px" }}>
              <h4>{view.toUpperCase()} VIEW</h4>
              <a href={urls.dxf} target="_blank" rel="noopener noreferrer">
                <button>Download {view} DXF</button>
              </a><br /><br />
              <a href={urls.pdf} target="_blank" rel="noopener noreferrer">
                <button>Download {view} PDF</button>
              </a><br /><br />
              <iframe
                src={urls.pdf}
                width="600"
                height="400"
                title={`${view} preview`}
                style={{ border: "1px solid black" }}
              ></iframe>
            </div>
          ))}
        </div>
      )}

      <br />
      <button onClick={() => navigate("/previous-page")}>
        <img src={backButton} alt="Back" width="60" height="60" />
      </button>
    </div>
  );
};

export default StepTo2D;
